import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteSMReceiptRequest {
  attachIds: number[];
}

const useDeleteScanManagerReceiptsApi = () => {
  const call = useCallback(async (params?: DeleteSMReceiptRequest) => {
    try {
      const res = await axiosInstance.post(api.deleteScanManagerReceiptRecord, params?.attachIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);
  const { execute, isLoading } = useAsync(call, false);

  return { deletePendingReceiptAttachments: execute, isDeleteReceiptAttachmentsLoading: isLoading };
};

export default useDeleteScanManagerReceiptsApi;
